import { Col, Row } from "antd";
import NavBar from "../../../Header/NavBar";
import Sidemenu from "../../../Sidemenu/Sidemenu";
// import PrivateLive from "./PrivateLive";
import LatestPrivatelive from "./LatestPrivatelive";
// import Recordmainbody from "./Recordmainbody";
import { useParams } from "react-router-dom";
// import ThreeWayTable from "./ThreeWayTable";
// import LatestThreeWayTable from "./LatestThreeWayTable";
import LatestThreeWayTable from "./LatestThreeWayTable";
import ModalPopUpCCI from "../LCAFiles/ModalPopUpCCI";

const LatestThreeWayDesktop = () => {
  const { id } = useParams();
  console.log(id,"idd")

  return (
    <>
      <NavBar />
      <div className="body-bg">
        <Row className="desktop-conversaction-body">
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={2}
            xl={2}
            className="body-margin-top body-margin-bottom-mobile"
          >
            <Sidemenu />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={5}
            xl={5}
            // className="volvex-avatar-list-body"
            className="volvex-private-podlist"
          >
            <LatestPrivatelive />
          </Col>
          {id ? (
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={17}
              xl={17}
              className="dashboard-board-background"
            >
              <LatestThreeWayTable />
            </Col>
          ) : (
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={17}
              xl={17}
              className="volvex-chat-body"
            ></Col>
          )}
       
           <ModalPopUpCCI/>
         
        </Row>
      </div>
    </>
  );
};
export default LatestThreeWayDesktop;
